import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoginService } from './login.service';

@Injectable({
    providedIn: 'root'
})
export class CatalogoService {
    private apiUrl: string;

    constructor(
        private http: HttpClient,
        private loginService: LoginService
    ) {
        this.apiUrl = environment.API_BACK;
    }

    private getLang(): string {
        return sessionStorage.getItem('lang') || 'es';
    }

    private handleError(error: HttpErrorResponse) {
        console.error('[CatalogoService] Error en la petición:', error);

        if (error.status === 401) {
            console.debug('[CatalogoService] Error de autenticación:', {
                token: this.loginService.getToken(),
                headers: error.headers,
                error: error.error
            });

            // Solo hacer logout si realmente no hay token
            if (!this.loginService.getToken()) {
                this.loginService.logout();
                return throwError(() => new Error('Sesión expirada o inválida'));
            }
            return throwError(() => new Error('Error de autenticación'));
        }

        return throwError(() => new Error(error.message || 'Error en el servidor'));
    }

    public getProducts(): Observable<any> {
        console.debug('[CatalogoService] Obteniendo lista de productos');
        const url = `${this.apiUrl}product/list?state=1&type=0&lang=${this.getLang()}`;

        return this.http.get(url, {
            headers: this.loginService.getHeaders(true)
        }).pipe(
            map(response => {
                console.debug('[CatalogoService] Respuesta productos:', response);
                return response;
            }),
            catchError(error => this.handleError(error))
        );
    }

    public getProductsLudico(): Observable<any> {
        console.debug('[CatalogoService] Obteniendo productos lúdicos');
        const url = `${this.apiUrl}product/list?state=1&type=1&lang=${this.getLang()}`;

        return this.http.get(url, {
            headers: this.loginService.getHeaders(true)
        }).pipe(
            map(response => {
                console.debug('[CatalogoService] Respuesta productos lúdicos:', response);
                return response;
            }),
            catchError(error => this.handleError(error))
        );
    }

    public getProduct(productId: string): Observable<any> {
        if (!productId) {
            return throwError(() => new Error('ID de producto requerido'));
        }

        console.debug(`[CatalogoService] Obteniendo detalle del producto ${productId}`);
        const url = `${this.apiUrl}product/list?state=1&id_product=${productId}&lang=${this.getLang()}`;

        return this.http.get(url, {
            headers: this.loginService.getHeaders(true)
        }).pipe(
            map(response => {
                console.debug('[CatalogoService] Respuesta detalle producto:', response);
                return response;
            }),
            catchError(error => this.handleError(error))
        );
    }
}
